import * as Models from '../../models/models-index';
import { Filter } from '../filter.model';

export class FilterOptions {
  includeAdvanced: boolean;
  includeLookback: boolean;
  includeMOM: boolean;
  includeTrend: boolean;
  includeYOY: boolean;
}

export class ReportFilters {
  reportName: string;
  filters: Filter[];
}

export class ReportViewFilters {
  reportName: string;
  filters: Models.ReportViewFilter[];
}

export class ReportViewFilterSelections {
  reportName: string;
  selections: Models.ReportViewFilterSelection[];
}

export interface FilterState {
  filters: ReportFilters[];
  reportViewFilters: Models.ReportViewFilter[];
  reportViewFilterSelections: ReportViewFilterSelections[];
  lockedFilters: Filter[];
  lockedReportViewFilters: Models.ReportViewFilterSelection[];
  explicitUnlockedFilters: string[];
  options: FilterOptions;
  reportViewFilterConfigurations: Models.ReportViewFilterConfiguration[];
}

export const initialFilterState: FilterState = {
  filters: [],
  reportViewFilters: [],
  reportViewFilterSelections: [],
  lockedFilters: [],
  lockedReportViewFilters: [],
  explicitUnlockedFilters: [],
  options: {
    includeAdvanced: false,
    includeLookback: false,
    includeMOM: false,
    includeTrend: false,
    includeYOY: false
   },
  reportViewFilterConfigurations: []
};
